"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _classnames4 = require("classnames");

var _classnames5 = _interopRequireDefault(_classnames4);

var _components = require("components");

var _Button = require("../../components/Button");

var _Button2 = _interopRequireDefault(_Button);

var _TextButton = require("../../components/TextButton");

var _TextButton2 = _interopRequireDefault(_TextButton);

var _styles = require("./styles.scss");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var textButton = (0, _glamor.css)({
  marginLeft: 2,
  marginRight: 2,
  "& button": {
    margin: 0,
    fontFamily: "Roboto, Source Sans Pro, sans-serif;",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.25px"
  }
});

var TrialWelcomePopup = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(TrialWelcomePopup, _React$Component);

  function TrialWelcomePopup() {
    (0, _classCallCheck3.default)(this, TrialWelcomePopup);
    return (0, _possibleConstructorReturn3.default)(this, (TrialWelcomePopup.__proto__ || (0, _getPrototypeOf2.default)(TrialWelcomePopup)).apply(this, arguments));
  }

  (0, _createClass3.default)(TrialWelcomePopup, [{
    key: "render",
    value: function render() {
      var _classnames,
          _classnames2,
          _classnames3,
          _this2 = this;

      var onCloseYes = this.props.onCloseYes;

      var megascans = (0, _classnames5.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, _styles2.default["icon"], true), (0, _defineProperty3.default)(_classnames, _styles2.default["megascans"], true), _classnames));
      var mixer = (0, _classnames5.default)((_classnames2 = {}, (0, _defineProperty3.default)(_classnames2, _styles2.default["icon"], true), (0, _defineProperty3.default)(_classnames2, _styles2.default["mixer"], true), _classnames2));
      var bridge = (0, _classnames5.default)((_classnames3 = {}, (0, _defineProperty3.default)(_classnames3, _styles2.default["icon"], true), (0, _defineProperty3.default)(_classnames3, _styles2.default["bridge"], true), _classnames3));

      var getStarted = {
        label: "Get Started",
        onClick: function onClick() {
          var router = _this2.context.router;

          router.push({
            pathname: "/megascans/library"
          });
          onCloseYes();
        },
        primary: true,
        small: true,
        smallSize: true,
        disabled: false
      };

      return _react2.default.createElement(
        _components.Popup,
        null,
        _react2.default.createElement(
          _components.Popup.Header,
          null,
          "Success"
        ),
        _react2.default.createElement(
          _components.Popup.Content,
          null,
          _react2.default.createElement(
            "div",
            { className: _styles2.default.container },
            _react2.default.createElement(
              "div",
              { className: _styles2.default.iconContainer },
              _react2.default.createElement("span", { className: megascans }),
              _react2.default.createElement("span", { className: mixer }),
              _react2.default.createElement("span", { className: bridge })
            ),
            _react2.default.createElement(
              "div",
              { className: _styles2.default.para },
              "Welcome to your Megsascans trial!",
              _react2.default.createElement("br", null),
              _react2.default.createElement("br", null),
              "Your free 30-day trial is now active. As part of this trial, you get access to the free section of Megascans library and full-featured access to Quixel Bridge and Mixer.",
              _react2.default.createElement("br", null),
              _react2.default.createElement("br", null),
              "This trial provides non-commercial access only."
            )
          )
        ),
        _react2.default.createElement(
          _components.Popup.Footer,
          null,
          _react2.default.createElement(
            "div",
            { className: _styles2.default.actionButton },
            _react2.default.createElement(_TextButton2.default, {
              className: textButton,
              type: "button",
              label: "Learn More",
              mode: "small-normal",
              to: "/terms",
              onClick: onCloseYes
            }),
            _react2.default.createElement(
              "div",
              { className: _styles2.default.button },
              _react2.default.createElement(_Button2.default, getStarted)
            )
          )
        )
      );
    }
  }]);
  return TrialWelcomePopup;
}(_react2.default.Component), _class.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = TrialWelcomePopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/EpicEula/TrialPopup/TrialWelcomePopup/TrialWelcomePopup.jsx
// module id = 2564
// module chunks = 0